module.exports = __webpack_public_path__ + "static/media/5-Stars.5cb8fdda.svg";